import '@splidejs/react-splide/css';

import PageNationNextIcon from '@assets/images/common/icon/pagination/next.svg';
import PageNationPrevIcon from '@assets/images/common/icon/pagination/prev.svg';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { useRef } from 'react';
import { Link } from 'react-router-dom';

interface ScrollItem {
  to: string;
  label: string;
  isCurrent: boolean;
}

interface UseScrollMobileProps<T extends ScrollItem> {
  items: T[];
  itemClassName?: string;
}

export const useScrollMobile = <T extends ScrollItem>({
  items,
  itemClassName = 'flex-[0_0_auto] truncate border-b border-solid border-b-gray-200 px-[6px] py-[10px] text-sm',
}: UseScrollMobileProps<T>) => {
  const splideRef = useRef<Splide>(null);

  const renderItems = () => (
    <Splide
      hasTrack={false}
      ref={splideRef}
      options={{
        arrows: true,
        pagination: false,
        pauseOnHover: false,
        autoWidth: true,
        focus: 0,
        omitEnd: true,
      }}
    >
      <SplideTrack className='!pr-[24px]'>
        {items.map((item) => (
          <SplideSlide
            key={item.to}
            className={`${itemClassName} ${
              item.isCurrent ? '!border-b-2 border-b-primary-500 text-primary-500' : ''
            }`}
          >
            <Link to={item.to}>{item.label}</Link>
          </SplideSlide>
        ))}
      </SplideTrack>
      <div className='splide__arrows'>
        <button className='splide__arrow splide__arrow--prev !left-0 !size-6 rounded-full !border !border-solid !border-gray-200 !bg-gray-50 !opacity-100 disabled:!opacity-0'>
          <img
            src={PageNationPrevIcon}
            alt=''
            width={6}
            height={10}
          />
        </button>
        <button className='splide__arrow splide__arrow--next !right-[24px] !size-6 rounded-full !border !border-solid !border-gray-200 !bg-gray-50 !opacity-100 disabled:!opacity-0'>
          <img
            src={PageNationNextIcon}
            alt=''
            width={6}
            height={10}
          />
        </button>
      </div>
    </Splide>
  );

  const renderScrollMobile = () => <div className='relative overflow-hidden'>{renderItems()}</div>;

  return {
    renderScrollMobile,
  };
};
